/**
 * Explanner Service Documentation
 * Explanner Service Documentation
 *
 * The version of the OpenAPI document: 1.7_landesstelle{20240611@153537}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SortOption { 
    path?: string;
    /**
     * ASC/DESC
     */
    sorting?: SortOption.SortingEnum;
}
export namespace SortOption {
    export type SortingEnum = 'ASC' | 'DESC';
    export const SortingEnum = {
        Asc: 'ASC' as SortingEnum,
        Desc: 'DESC' as SortingEnum
    };
}


